import { useCallback, useState } from 'react'

import { Currency } from '../../sdk'

export type LiquidityTokenField = 'A' | 'B'

/** Estado local del modal de búsqueda de tokens en flujos add/remove (navegación vía controller). */
export function useLiquidityTokenSearch() {
  const [open, setOpen] = useState(false)
  const [activeField, setActiveField] = useState<LiquidityTokenField | null>(null)

  const openForField = useCallback((field: LiquidityTokenField) => {
    setActiveField(field)
    setOpen(true)
  }, [])

  const close = useCallback(() => {
    setOpen(false)
    setActiveField(null)
  }, [])

  const selectCurrency = useCallback(
    (
      currency: Currency,
      onSelect: (field: LiquidityTokenField, currency: Currency) => void,
    ) => {
      if (activeField == null) return
      onSelect(activeField, currency)
      close()
    },
    [activeField, close],
  )

  return {
    open,
    activeField,
    openForField,
    close,
    selectCurrency,
  }
}

export type LiquidityTokenSearchState = ReturnType<typeof useLiquidityTokenSearch>
